import callApi from 'lib/callApi';
import { showFailureToast, showSuccessToast } from 'lib/ToastHelper';
import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const ChangeRoleModal = ({
  isOpen,
  onClose,
  currentRole,
  targetRole,
  memberId,
  companyId,
  onRoleChanged,
}) => {
  const [isChangingRole, setIsChangingRole] = React.useState(false);

  const changeMemberRole = async () => {
    const url = 'profiles/colleague/change-member-role/';
    const data = {
      id: memberId,
      role: targetRole,
      company_id: companyId,
    };

    try {
      const res = await callApi(url, 'POST', {}, data);

      if (res.status === 201 || res.status === 200) {
        showSuccessToast('Success! ' + res.data.message);
        onRoleChanged(targetRole);
      }
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.toString();
      showFailureToast('Failed! ' + errorMessage);
    }
  };

  const handleConfirm = async () => {
    setIsChangingRole(true);
    await changeMemberRole();
    setIsChangingRole(false);
    onClose();
  };

  const formatRole = (role) => {
    return role.charAt(0).toUpperCase() + role.toLowerCase().slice(1);
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="sm">
      <ModalHeader>Change Role</ModalHeader>
      <ModalBody>
        Are you sure you want to modify this user&apos;s role from{' '}
        <strong>{formatRole(currentRole)}</strong> to{' '}
        <strong>{formatRole(targetRole)}</strong>?
      </ModalBody>
      <ModalFooter>
        <Button
          color="secondary"
          size="sm"
          onClick={onClose}
          disabled={isChangingRole}
        >
          Cancel
        </Button>
        <Button
          color="danger"
          size="sm"
          onClick={handleConfirm}
          disabled={isChangingRole}
        >
          Confirm
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ChangeRoleModal;
